const DoubleNoteAnimated = ({scale, color, position, begin=0, duration=3}) => {

  return (
    <svg width={100} height={370} style={{position:'absolute', left:position.x, top:position.y, transform:`scale(${scale})`}} >
      <g transform={`matrix(-1,0,0,-1,539.0272,260.8595)`}>
        <animateMotion
          dur={`${duration}s`}
          begin={`${begin}s`}
          repeatCount="indefinite"
          path="M20.0632 309.3068 C 32.6987 293.8344, 37.3663 283.7542, 37.3626 271.9472 C 37.3597 262.9031, 35.3050 258.3229, 21.9093 237.5000 C 3.6335 209.0914, 2.6068 199.5020, 15.9610 181.9444 C 18.0526 179.1944, 21.9238 174.1060, 24.5635 170.6368 C 33.3341 159.1101, 36.2724 151.0727, 35.0833 141.8610 C 33.8383 132.2161, 31.2071 126.1103, 13.2134 91.1111 C -4.8236 56.0276, -4.1581 39.5899, 16.5803 7.9390"
        />
        <path
           d="M 483.27303,219.83179 C 479.87719,221.65176 478.06775,224.94634 479.18081,227.42475 C 480.36807,230.06839 484.44782,230.81447 488.28739,229.09012 C 492.12695,227.36576 494.27955,223.82072 493.09229,221.17709 C 491.90502,218.53345 487.82528,217.78737 483.98571,219.51172 C 483.74574,219.61949 483.49943,219.71046 483.27303,219.83179 z "
           style={{
            opacity:0.9,
            fill:color,
            fillOpacity:1,
            fillRule:'evenodd',
            stroke:'none',
            strokeWidth:0.2,
            strokeMiterlimit:4,
            strokeDashoffset:0,
            strokeOpacity:1
          }}
        />
        <path
          d="M 479.64053,226.16518 L 479.64053,259.75275"
          style={{
            fill:'none',
            fillOpacity:0.75,
            fillRule:'evenodd',
            stroke:color,
            strokeWidth:1.5,
            strokeLinecap:'butt',
            strokeLinejoin:'miter',
            strokeMiterlimit:4,
            strokeDasharray:'none',
            strokeOpacity:1
          }}
        />
        <path
          d="M 528.88143,219.47819 C 525.48559,221.29816 523.67615,224.59274 524.78921,227.07115 C 525.97647,229.71479 530.05622,230.46087 533.89579,228.73652 C 537.73535,227.01216 539.88795,223.46712 538.70069,220.82349 C 537.51342,218.17985 533.43368,217.43377 529.59411,219.15812 C 529.35414,219.26589 529.10783,219.35686 528.88143,219.47819 z "
          style={{
            opacity:0.9,
            fill:color,
            fillOpacity:1,
            fillRule:'evenodd',
            stroke:'none',
            strokeWidth:0.2,
            strokeMiterlimit:4,
            strokeDashoffset:0,
            strokeOpacity:1
          }}
        />
        <path
           d="M 525.24893,225.81158 L 525.24893,259.39915"
           style={{
            fill:'none',
            fillOpacity:0.75,
            fillRule:'evenodd',
            stroke:color,
            strokeWidth:1.5,
            strokeLinecap:'butt',
            strokeLinejoin:'miter',
            strokeMiterlimit:4,
            strokeDasharray:'none',
            strokeOpacity:1
          }}
        />
        <rect
           y="256.51352"
           x="478.81485"
           height="4.3461943"
           width="47.211941"
           style={{
            opacity:0.9,
            fill:color,
            fillOpacity:1,
            fillRule:'evenodd',
            stroke:'none',
            strokeWidth:0.5,
            strokeMiterlimit:4,
            strokeDasharray:'none',
            strokeDashoffset:0,
            strokeOpacity:1}} />
      </g>
    </svg>
  );
}
export default DoubleNoteAnimated;